<template>
	<div id="page">

		<Header></Header>

		<div class="newsContent">
			<div class="container">
				<div class="crumbs">
          <router-link :to="'/'">首页 ></router-link>
          <router-link :to="'/industryNews.html'" v-if="news.news_category == '2'">{{ news.news_category_name }} ></router-link>
          <router-link :to="'/news.html'" v-if="news.news_category == '3'">{{ news.news_category_name }} ></router-link>
          <router-link :to="'/commonSense.html'" v-if="news.news_category == '4'">{{ news.news_category_name }} ></router-link>
          <a>新闻详情</a>
				</div>

				<div class="content">
					<h1>{{ news.news_title }}</h1>
					<div class="note">发布者：{{ news.news_display_user }} &nbsp;  发布日期：{{ news.news_display_date }}</div>
					<div class="contentDiv" v-html="news.news_content">
						<p v-html="news.news_content"></p>
					</div>
				</div>
			</div>
		</div>

		<Footer></Footer>

	</div>
</template>

<script>
	import Header from '../../components/Header.vue';
	import Footer from '../../components/Footer.vue';

  import { getNews } from '../../axios/api';

	export default {
    data() {
      return {
        cid: this.$route.params.cid ? (typeof(this.$route.params.cid) === "object" ? 3 : Number(this.$route.params.cid)) : 3,
        id: this.$route.params.id ? (typeof(this.$route.params.id) === "object" ? 1 : Number(this.$route.params.id)) : 1,
        news: {},
      }
    },

    components: {
      Header,
      Footer
    },

    created(){
      this.getNewsDetail({'id': this.id, 'filter_params': {'news_display': 1}})
    },

    mounted() {
      $("#nav ul li:nth-child(4) a.parent").addClass("router-link-exact-active");
      setTimeout(function(){
        $(".contentDiv img").parent().css({
          "text-align":"center",
          "display":"block"
        })
      }, 150);
    },

    methods: {
      getNewsDetail(query) {
        getNews(query).then(response => {
          this.news = response.data.data.item;
        });
      }
    },
	}
</script>

<style type="text/css" scoped>

	.newsContent{
		min-height: 500px;
	}
	.newsContent .container{
		max-width: 1240px;
	}
	.newsContent .content{
		padding: 42px 90px;
	}
	.newsContent .content h1{
		font-size: 40px;
		color: #333333;
		font-weight: normal;
		letter-spacing: 2px;
	}
	.newsContent .crumbs{
		padding-top: 20px;
	}
	.newsContent .crumbs a{
		color: #666666;
		font-size: 14px;
	}
	.note{
		font-size: 13px;
		color: #999999;
	}
	.contentDiv{
		margin-top: 65px;
	}
	.contentDiv p{
		font-size: 17px;
		color: #666666;
		text-indent: 36px;
		margin-bottom: 0;
		line-height: 30px;
	}
	@media(max-width:767px){
		.newsContent .content h1{
			font-size: 24px;
		}
		.newsContent .content{
			padding: 20px 0;
		}
		.contentDiv {
		    margin-top: 30px;
		}

	}
</style>


<style>
	.contentDiv img{
		    max-width: 100% !important;
		    height: auto;
	}
	.contentDiv p{
		margin-bottom: 0;
	}
</style>



// WEBPACK FOOTER //
// src/page/news/_id.vue